<!-- Region 5 panel for FOUR rails: recruitment_customer, recruitment_professional,
     mari_customer, mari_professional. Everything that differs between them lives in
     RAIL_CONFIG below — read one row to know one rail. -->
<template>
  <div class="v2026-recruitment-panel">

    <PanelCollapseBarV2026 :ariaLabel="rail.collapseLabel"
                           @toggleCollapse="$emit('toggleCollapse')" />

    <PanelTabBarV2026 :activeTab="activeTab" :disabledTabs="disabledTabs"
                      :labels="tabLabels" :showAi="rail.aiTab" @setTab="setTab" />

    <PanelSubTabBarV2026 v-if="showSubTabBar"
                         :items="visibleSubTabs"
                         :activeKey="activeSubKey"
                         @select="goToSubTab" />

    <div class="v2026-rp-scroll" ref="subTabScroll">

    <div class="v2026-rp-tabpane" v-if="activeTab === 1">

      <PanelHeaderV2026 :type="rail.widgetType"
                        :statusIcons="headerStatusIcons"
                        :avatarUrl="avatarUrl"
                        :channelBadge="channelBadge"
                        :displayName="headerName"
                        :roleLabel="rail.roleLabel"
                        addLabel="เพิ่มชื่อ"
                        :canEdit="hasConv"
                        :convCustomer="conv"
                        :conversationId="conversationId"
                        :customerType="selectedConversation && selectedConversation.customer_type"
                        :professional="conv && conv.beneat_professional"
                        :beneatUserId="conv && conv.beneat_user_id"
                        :beneatUserHref="headerUserHref"
                        @notify="showToast($event.variant, $event.title, $event.message)" />

      <ImportantMessageV2026 v-if="conv" :customer="conv" :conversationId="conversationId" />

      <UserInfoCardV2026 v-if="hasContactRow"
                         :type="rail.widgetType"
                         :dynamicRows="true"
                         :idValue="entityIdValue"
                         :phone="phone"
                         :email="email"
                         :hasEmail="true"
                         :idHref="entityIdHref"
                         :canEdit="hasConv"
                         :convCustomer="conv"
                         :conversationId="conversationId"
                         @notify="showToast($event.variant, $event.title, $event.message)" />

      <TagsSectionV2026 :type="rail.widgetType" :selectedConversation="selectedConversation"
                        :tags="tags" :admin="admin"
                        @notify="showToast($event.variant, $event.title, $event.message)" />

      <div class="v2026-rp-system" v-if="cust">
        <span class="v2026-rp-section-label">ข้อมูลลูกค้าในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="customerAvatar"
                         :displayName="cust.full_name"
                         idLabel="User ID:"
                         :idValue="cust.id"
                         :idHref="linkProfileUser(cust.id)" />
      </div>
      <div class="v2026-rp-system" v-if="pro">
        <span class="v2026-rp-section-label">ข้อมูลคุณแม่บ้านในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="professionalAvatar"
                         :displayName="pro.full_name"
                         idLabel="Provider ID:"
                         :idValue="pro.id"
                         :idHref="linkProfileProfessional(pro.id)" />
      </div>
      <div class="v2026-rp-system" v-if="app">
        <span class="v2026-rp-section-label">ข้อมูลผู้สมัครในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="placeholderAvatar"
                         :displayName="app.full_name"
                         idLabel="Applicant ID:"
                         :idValue="app.id" />
      </div>

      <div class="v2026-rp-empty" v-if="!cust && !pro && !app">
        ยังไม่พบข้อมูลผู้ติดต่อรายนี้ในระบบ BeNeat
      </div>
      <div  v-if="rail.caseDate" class="v2026-rp-system">
         <ConversationCaseDateV2026 v-if="rail.caseDate" :selectedConversation="selectedConversation" />
      </div>
    </div><!-- /TAB 1 -->

    <div class="v2026-rp-tabpane v2026-rp-notes" v-if="activeTab === 2">
      <SystemNotesV2026 ref="secSystemNotes" v-if="noteContext" :type="noteContext.type"
                        :entityId="noteContext.id" :admin="admin" />
      <ChatNoteV2026 ref="secChatNote" v-if="conv" :type="rail.widgetType" :customer="conv"
                     :conversationId="conversationId"
                     @notify="showToast($event.variant, $event.title, $event.message)" />
      <div class="v2026-rp-empty" v-if="!rail.caseDate && !noteContext && !conv">
        ยังไม่มีโน้ตสำหรับแชทนี้
      </div>
    </div><!-- /TAB 2 -->

    <div class="v2026-rp-tabpane" v-if="activeTab === 4 && canSeeAi">
      <TranslateAssistantV2026 :selectedConversation="selectedConversation"
                               @notify="showToast($event.variant, $event.title, $event.message)" />
    </div><!-- /TAB 4 -->

    </div><!-- /v2026-rp-scroll -->

    <BaseToast :open="toast.open" :variant="toast.variant" :title="toast.title" :message="toast.message"
               @close="toast.open = false" />

  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseToast from '@/components/coversation/BaseToast.vue'
import PanelCollapseBarV2026 from '@/components/coversation/PanelCollapseBarV2026.vue'
import PanelTabBarV2026 from '@/components/coversation/PanelTabBarV2026.vue'
import PanelSubTabBarV2026 from '@/components/coversation/PanelSubTabBarV2026.vue'
import panelSubTabs2026 from '@/components/coversation/panelSubTabs2026'
import PanelHeaderV2026 from '@/components/coversation/PanelHeaderV2026.vue'
import ImportantMessageV2026 from '@/components/coversation/ImportantMessageV2026.vue'
import UserInfoCardV2026 from '@/components/coversation/UserInfoCardV2026.vue'
import TagsSectionV2026 from '@/components/coversation/TagsSectionV2026.vue'
import EntityCardV2026 from '@/components/coversation/EntityCardV2026.vue'
import ConversationCaseDateV2026 from '@/components/coversation/ConversationCaseDateV2026.vue'
import SystemNotesV2026 from '@/components/coversation/SystemNotesV2026.vue'
import ChatNoteV2026 from '@/components/coversation/ChatNoteV2026.vue'
import TranslateAssistantV2026 from '@/components/coversation/TranslateAssistantV2026.vue'
import { resolveStatusIcons } from '@/components/coversation/statusIconCatalog'

const AI_TAB = 4
const FALLBACK_ACTIVE_TAB = 1
const PLACEHOLDER_AVATAR = 'https://beneat.co/static/img/unknown.png'

// One row per rail this panel serves. The two recruitment rows are the literals the
// recruitment rails already shipped with, so nothing on those rails can move.
const RAIL_CONFIG = {
  recruitment_customer: {
    defaultTab: AI_TAB,
    aiTab: true,
    caseDate: true,
    widgetType: 0,
    idOrder: ['pro', 'cust', 'app'],
    tab1Label: 'ข้อมูลลูกค้า',
    collapseLabel: 'ย่อแผงข้อมูลลูกค้า',
    roleLabel: 'คุณลูกค้า (Recruit)'
  },
  recruitment_professional: {
    defaultTab: AI_TAB,
    aiTab: true,
    caseDate: true,
    widgetType: 1,
    idOrder: ['pro', 'cust', 'app'],
    tab1Label: 'ข้อมูลคุณแม่บ้าน',
    collapseLabel: 'ย่อแผงข้อมูลคุณแม่บ้าน',
    roleLabel: 'คุณแม่บ้าน (Recruit)'
  },
  mari_customer: {
    defaultTab: 1,
    aiTab: false,
    caseDate: false,
    widgetType: 0,
    idOrder: ['cust', 'pro', 'app'],
    tab1Label: 'ข้อมูลลูกค้า',
    collapseLabel: 'ย่อแผงข้อมูลลูกค้า',
    roleLabel: 'คุณลูกค้า (Mari)'
  },
  mari_professional: {
    defaultTab: 1,
    aiTab: false,
    caseDate: false,
    widgetType: 0,
    idOrder: ['cust', 'pro', 'app'],
    tab1Label: 'ข้อมูลผู้สมัคร',
    collapseLabel: 'ย่อแผงข้อมูลผู้สมัคร',
    roleLabel: 'ผู้สมัคร (Mari)'
  }
}

export default {
  name: 'recruitment-panel-v2026',
  mixins: [panelSubTabs2026],
  components: {
    BaseToast,
    PanelCollapseBarV2026,
    PanelTabBarV2026,
    PanelSubTabBarV2026,
    PanelHeaderV2026,
    ImportantMessageV2026,
    UserInfoCardV2026,
    TagsSectionV2026,
    EntityCardV2026,
    ConversationCaseDateV2026,
    SystemNotesV2026,
    ChatNoteV2026,
    TranslateAssistantV2026
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeTab: FALLBACK_ACTIVE_TAB,
      tabPinnedByUser: false,
      subTabScrollRef: 'subTabScroll',
      // Tab 2 only: a tab with no entry gets no strip and no spy work.
      subTabs: {
        2: [
          { key: 'sysnote', label: 'โน้ตในระบบ', refs: ['secSystemNotes'] },
          { key: 'chatnote', label: 'โน้ตแชท', refs: ['secChatNote'] }
        ]
      },
      placeholderAvatar: PLACEHOLDER_AVATAR,
      icons: {
        line: require('@/assets/icons2026/line-color.svg'),
        facebook: require('@/assets/icons2026/facebook-color.svg')
      },
      toast: { open: false, variant: 'success', title: '', message: '' }
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('tag', ['tags']),
    ...mapState('conversation', ['customerType']),
    ...mapState('aiAssistant', ['departmentIds']),

    // An unrecognised customerType gets the safe row: no AI, opens on tab 1.
    rail () {
      return RAIL_CONFIG[this.customerType] || RAIL_CONFIG.mari_customer
    },
    // The rail gate goes IN FRONT of the department gate: a Mari rail has no AI for any
    // admin, so the tab-4 pane and the promoting watcher below stay dead there.
    canSeeAi () {
      return this.rail.aiTab && !!(this.admin && Array.isArray(this.departmentIds) &&
        this.departmentIds.includes(this.admin.department_id))
    },
    disabledTabs () {
      return this.canSeeAi ? [3] : [3, 4]
    },
    tabLabels () {
      return {
        tab1: this.rail.tab1Label,
        tab2: 'โน้ต',
        tab3: 'ตารางงาน',
        tab4: 'ผู้ช่วย AI แปลภาษา'
      }
    },

    // A failed searchCustomer lookup returns an error object; it must not be read as data.
    matched () {
      return (this.customer && !this.customer.error) ? this.customer : null
    },
    cust () {
      return (this.matched && this.matched.customer) ? this.matched.customer : null
    },
    pro () {
      return (this.matched && this.matched.professional) ? this.matched.professional : null
    },
    app () {
      return (this.matched && this.matched.applicant) ? this.matched.applicant : null
    },
    conv () {
      return (this.selectedConversation && this.selectedConversation.customer)
        ? this.selectedConversation.customer : null
    },
    // Guarded on the id so a missing one yields null, never ".../user/undefined".
    headerUserHref () {
      const id = this.conv && this.conv.beneat_user_id
      return id ? this.linkProfileUser(id) : null
    },
    conversationId () {
      return this.selectedConversation ? this.selectedConversation.id : null
    },
    hasConv () {
      return this.conv !== null
    },

    noteContext () {
      if (this.cust) return { type: 0, id: this.cust.id }
      if (this.pro) return { type: 1, id: this.pro.id }
      if (this.app) return { type: 2, id: this.app.id }
      return null
    },

    professionalAvatar () {
      const pic = this.pro && this.pro.picture
      if (!pic) return PLACEHOLDER_AVATAR
      if (/^(https?:)?\/\//.test(pic)) return pic
      return `https://beneat.s3-ap-southeast-1.amazonaws.com/professionals/${pic}`
    },
    customerAvatar () {
      return (this.cust && this.cust.picture) ? this.cust.picture : PLACEHOLDER_AVATAR
    },
    avatarUrl () {
      if (this.pro) return this.professionalAvatar
      if (this.cust) return this.customerAvatar
      return PLACEHOLDER_AVATAR
    },
    // '' rather than '-': the empty string is what triggers the ＋เพิ่มชื่อ pill.
    // Same icons the chat card puts before the name.
    headerStatusIcons () {
      const ids = this.selectedConversation && this.selectedConversation.status_icons
      return resolveStatusIcons(Array.isArray(ids) ? ids : [])
    },
    headerName () {
      const n = this.conv && this.conv.name
      if (n && String(n).trim()) return n
      if (this.pro && this.pro.full_name) return this.pro.full_name
      if (this.cust && this.cust.full_name) return this.cust.full_name
      if (this.app && this.app.full_name) return this.app.full_name
      return ''
    },
    channelBadge () {
      const type = this.selectedConversation ? this.selectedConversation.type : null
      switch (type) {
        case 'LineAtConversation':
        case 'LineProfessionalConversation':
          return { icon: this.icons.line, alt: 'LINE' }
        case 'PublicConversation':
          return { icon: this.icons.facebook, alt: 'Facebook' }
        default:
          return null
      }
    },

    // UserInfoCardV2026 takes its ID label from its own type registry, so the rail decides
    // which record should win the row: the professional on recruitment, the customer on Mari.
    firstEntityKey () {
      return this.rail.idOrder.find(key => this[key]) || null
    },
    entityIdValue () {
      return this.firstEntityKey ? this[this.firstEntityKey].id : null
    },
    entityIdHref () {
      if (this.firstEntityKey === 'pro') return this.linkProfileProfessional(this.pro.id)
      if (this.firstEntityKey === 'cust') return this.linkProfileUser(this.cust.id)
      return null
    },
    phone () {
      if (this.conv && this.conv.phone) return this.conv.phone
      if (this.pro && this.pro.phone) return this.pro.phone
      return (this.cust && this.cust.phone) ? this.cust.phone : null
    },
    email () {
      if (this.conv && this.conv.email) return this.conv.email
      if (this.pro && this.pro.email) return this.pro.email
      return (this.cust && this.cust.email) ? this.cust.email : null
    },
    hasContactRow () {
      return this.entityIdValue != null || this.nonEmpty(this.phone) || this.nonEmpty(this.email)
    }
  },
  watch: {
    // Safety net for a departmentIds fetch that resolves after mount.
    canSeeAi (v) {
      if (!v && this.activeTab === AI_TAB) {
        this.activeTab = FALLBACK_ACTIVE_TAB
      } else if (v && !this.tabPinnedByUser) {
        this.activeTab = this.rail.defaultTab
      }
    }
  },
  created () {
    this.activeTab = (this.rail.defaultTab === AI_TAB && !this.canSeeAi)
      ? FALLBACK_ACTIVE_TAB
      : this.rail.defaultTab
  },
  methods: {
    nonEmpty (v) {
      return v != null && String(v).trim() !== ''
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    setTab (n) {
      if (this.disabledTabs.indexOf(n) !== -1) return
      this.tabPinnedByUser = true
      this.activeTab = n
    },
    linkProfileUser (id) {
      return id != null ? `https://admin-test.beneat.co/user/${id}` : null
    },
    linkProfileProfessional (id) {
      return id != null ? `https://admin-test.beneat.co/professional/${id}/profile` : null
    }
  }
}
</script>

<style scoped>
.v2026-recruitment-panel {
  --v2026-color-main: #31C1D7;
  --v2026-color-main-soft: #31C1D714;
  --v2026-color-icon-idle: #66696C;
  --v2026-link: #007bff;
  --v2026-surface: #ffffff;
  --v2026-surface-sunken: #F8FAFC;
  --v2026-surface-hover: #e9ecf1;
  --v2026-border: #e4e7ec;
  --v2026-text: #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted: #98a2b3;
  --v2026-icon: #475467;
  --v2026-r-card: 12px;
  --v2026-r-box: 14px;
  --v2026-r-tab: 10px;
  --v2026-sp-1: 4px;
  --v2026-sp-2: 8px;
  --v2026-sp-3: 12px;
  --v2026-sp-4: 16px;
  --v2026-sp-5: 20px;
  --v2026-sp-6: 24px;
  --v2026-fs-section: 13px;
  --v2026-fs-body: 14px;
  --v2026-fs-meta: 12px;
  --v2026-fs-name: 16px;

  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
  height: 100%;
  overflow: hidden;
  background: var(--v2026-surface);
  padding: 0;
}

.v2026-rp-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: var(--v2026-sp-6);
}

.v2026-rp-tabpane {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
}

.v2026-rp-notes {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
}

.v2026-rp-system {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}
.v2026-rp-section-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}

.v2026-rp-empty {
  margin: 0 var(--v2026-sp-4);
  padding: var(--v2026-sp-5) var(--v2026-sp-4);
  border-radius: var(--v2026-r-card);
  background: var(--v2026-surface-sunken);
  font-size: var(--v2026-fs-body);
  color: var(--v2026-text-secondary);
  text-align: center;
}
</style>
